"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const parallaxRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const scrolled = window.scrollY;
        parallaxRef.current.style.transform = `translateY(${scrolled * 0.1}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="hero" className="relative min-h-screen overflow-hidden">
      <div className="grid lg:grid-cols-2 h-full min-h-screen">
        
        {/* LEFT COLUMN: Fixed Image Rendering */}
        {/* Added h-[50vh] lg:h-auto so it doesn't collapse on mobile */}
        <div className="relative overflow-hidden h-[50vh] lg:h-auto bg-gray-100">
          <img ref={parallaxRef} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/luxury_modern_villa_exterior_accra.png" alt="Luxury modern villa exterior in Accra" className="absolute inset-0 w-full h-[120%] object-cover brightness-110 contrast-105 saturate-110" style={{
          willChange: "transform",
          top: "-10%" // Gives the parallax effect room to move without showing empty edges
        }} />
          {/* Subtle overlay */}
          <div className="absolute inset-0 bg-primary/10" />
        </div>

        {/* RIGHT COLUMN: Text Content */}
        <div className="relative flex items-center justify-center px-6 sm:px-12 lg:px-16 xl:px-24 bg-background py-16 lg:py-0">
          <div ref={contentRef} className={`max-w-2xl transition-all duration-[var(--duration-medium)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
            <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground leading-tight mb-6">
              Don't Buy a Ghost Project.
              <br />
              <span className="text-primary">Buy Verified Reality.</span>
            </h1>

            <p className="text-lg sm:text-xl text-muted-foreground leading-relaxed mb-10 max-w-xl">
              The only developer in Accra that lets you audit the Land Title, view the Building Permit, and check the Litigation Status before you pay a deposit. Zero blind spots.
            </p>

            <a href="https://glass-house-portal.vercel.app">
              <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary/90 transition-colors" style={{
              backgroundColor: "var(--color-primary)",
              color: "var(--color-foreground-primary)"
            }}>
                Access the Data Room
              </Button>
            </a>
          </div>
        </div>
        
      </div>
    </section>;
}